import React, { useState } from "react"
import styled from "styled-components"
import { Col } from "react-bootstrap"

const ImageBlock = styled.div`
  position: relative;
  width: 100%;
  width: 300px;
  height: 300px;
  background: #242526;
  border-radius: 10px
`
const H2 = styled.h2`
  position: absolute;
  top: 205px;
  left: 5px;
  width: 100%;
  color: #3a96bc;
`
const Span = styled.span`
  color: white;
  font: 20px/20px Helvetica, Sans-Serif;
  letter-spacing: -1px;
  background: rgb(0, 0, 0); /* fallback color */
  background: rgba(0, 0, 0, 0.7);
  border-radius: 5px;
  padding: 5px;
`
const Spacer = styled.span`
  padding: 0 3px;
`
const Description = styled.div`
  color: #B0B3B8;
  display: flex;
  font-size: 16px;
  text-align: justify;
  padding: 15px;
`
export default function CardLM({ labMember }) {
  const [isShown, setIsShown] = useState(false)

  return (
    <Col style={{ padding: "5px" }}>
      <ImageBlock
        onMouseEnter={() => setIsShown(true)}
        onMouseLeave={() => setIsShown(false)}
      >
        {isShown === false && (
          <>
            <img
              src={labMember.Picture.publicURL}
              alt=""
              style={{
                width: 300,
                height: 300,
                borderRadius: "10px",
              }}
              className="imageLabMembers"
            />
            <H2>
              <Span>
                {labMember.Name}
              </Span>
                <br />
                <Spacer></Spacer>
              <Span>
                {labMember.Status}
              </Span>
            </H2>
          </>
        )}

        {isShown === true && (
          <>
            <div style={{ width: 300, height: 300, borderRadius: "10px" , cursor: "pointer"}}>
              <Description>{labMember.Description}</Description>
            </div>
          </>
        )}
      </ImageBlock>
    </Col>
  )
}
